import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { uploadEmployees } from '../../api/lib/employees';
import { employeesKeys } from 'src/features/employees/api/query-keys/employees';
import { ApiError } from 'src/types/interfaces/api-error';
import { delayedCallbackExecution } from 'src/utils/delayed-callback-execution';
import { isApiErrorMessage } from 'src/api/utils/is-api-error-message';
import { employeesApiErrorsTranslations } from '../../constants/api-errors-translations';
import { ApiErrorMessage } from '../types/api-error-message';

export const useUploadEmployees = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: (file: File) => uploadEmployees(file),
    onSuccess: () => {
      delayedCallbackExecution(1000, () => {
        queryClient.invalidateQueries({
          queryKey: employeesKeys.lists(),
        });
      });
      toast.success(t('employees:employees.uploadDialog.success'));

      onSuccess?.();
    },
    onError: (error: ApiError) => {
      const errorMessage = error?.response?.data?.message;
      const [errorMessageCode, payload] = errorMessage.split(':');

      if (
        isApiErrorMessage<ApiErrorMessage>(
          errorMessageCode,
          employeesApiErrorsTranslations,
        )
      ) {
        toast.error(
          `${t(employeesApiErrorsTranslations[errorMessageCode])}${payload || ''}`,
        );

        return;
      }
      toast.error(
        error?.response?.data?.message ||
          t('common:errorMessages.somethingWentWrong'),
      );
    },
  });
};
